var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ng-button',_vm._g(_vm._b({staticClass:"google-signin-button",attrs:{"lightweight":""}},'ng-button',_vm.$attrs,false),_vm.$listeners),[_c('img',{staticClass:"google-signin-button__icon",attrs:{"src":require("../../assets/img/google-icon.svg"),"height":"24px","width":"auto"}}),_vm._v(" "+_vm._s(_vm.$t('app.googleSignin'))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }